var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ballot-card card router-tab-touching-card"},[(_vm.isElection)?_c('office-setup-card'):_c('motion-setup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }